module.exports = __webpack_public_path__ + "2227c4f3b6cb8ceeb54884bf8d074ea3.png";